import React, { useMemo, useState } from "react";
import {
  Card,
  Typography,
  Row,
  Col,
  Divider,
  Drawer,
  Button,
  Space,
} from "antd";
import {
  GlobalOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const { Text, Title, Paragraph } = Typography;

const Preferences = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [terms, setTerms] = useState("");

  const orgSettings = useMemo(() => {
    const stored = sessionStorage.getItem("OrgSettings");
    return stored ? JSON.parse(stored) : {};
  }, []);

  const settings = [
    {
      icon: <CalendarOutlined style={{ color: "#1677ff" }} />,
      label: "Date Format",
      value: orgSettings.dateformat
        ? orgSettings.dateformat.split("|")[0]
        : "-",
    },
    {
      icon: <ClockCircleOutlined style={{ color: "#52c41a" }} />,
      label: "Default Time Zone",
      value: orgSettings.default_timezone || "-",
    },
    {
      icon: <GlobalOutlined style={{ color: "#fa8c16" }} />,
      label: "Time Format",
      value:
        orgSettings.time_format === "24"
          ? "24 Hours"
          : orgSettings.time_format === "12"
            ? "12 Hours"
            : "-",
    },
  ];

  const showTerms = (heading, value) => {
    setTitle(heading);
    setTerms(value || "No terms available.");
    setOpen(true);
  };

  return (
    <div
      style={{
        maxWidth: 390,
        margin: "20px auto",
        padding: "0 12px",
      }}
    >
      <Card
        bordered={false}
        style={{
          borderRadius: 16,
          boxShadow: "0 6px 18px rgba(0,0,0,.08)",
        }}
      >
        <Title level={4} style={{ marginBottom: 20 }}>
          Regional Settings
        </Title>

        {settings.map((item, index) => (
          <div key={index}>
            <Row align="middle">
              <Col span={2}>{item.icon}</Col>

              <Col span={14}>
                <Text type="secondary">{item.label}</Text>
              </Col>

              <Col span={8} style={{ textAlign: "right" }}>
                <Text strong>{item.value}</Text>
              </Col>
            </Row>

            <Divider style={{ margin: "14px 0" }} />
          </div>
        ))}

        <Row align="middle">
          <Col span={2}>
            <FileTextOutlined style={{ color: "#722ed1" }} />
          </Col>

          <Col span={14}>
            <Text type="secondary">Terms & Conditions</Text>
          </Col>

          <Col span={8} style={{ textAlign: "right" }}>
            <Space direction="vertical" size={4}>
              <Button
                type="link"
                size="small"
                onClick={() =>
                  showTerms(
                    "Invoice Terms & Conditions",
                    orgSettings.predefined_terms_invoice,
                  )
                }
              >
                Invoice
              </Button>

              <Button
                type="link"
                size="small"
                onClick={() =>
                  showTerms(
                    "Estimate Terms & Conditions",
                    orgSettings.predefined_terms_estimate,
                  )
                }
              >
                Estimate
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      <Drawer
        title={title}
        placement="bottom"
        open={open}
        onClose={() => setOpen(false)}
        height="55%"
        destroyOnClose
        styles={{
          body: {
            paddingBottom: 24,
          },
        }}
      >
        <Paragraph
          style={{
            whiteSpace: "pre-line",
            lineHeight: 1.8,
            marginBottom: 0,
          }}
        >
          {terms}
        </Paragraph>
      </Drawer>
    </div>
  );
};

export default Preferences;
